import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import closeeye from "../../assets/images/closeEye.svg";
import openeye from "../../assets/images/viewaction.svg";
import infoIcon from "../../assets/images/infobtnblue.svg";
import verifiedIcon from "../../assets/images/verified.svg";
import { commonservices } from "../../services/CommonServices";
import SubmitLoading from "../../component/common-component/Loaders/SubmitLoading";
import { useDispatch } from "react-redux";
import { UpdatePassword } from "../../services/ReduxTookit/Slice/UserRedux";
import MainpageLoader from "../../component/common-component/Loaders/MainpageLoader";

const ChangePassword = ({ setChangePass }) => {
  const dispatch = useDispatch();
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [C_passwordVisible, setC_PasswordVisible] = useState(false);
  // Add or remove 'loadtime' class based on MachineLoader

  useEffect(() => {
    if (Loading) {
      document.body.classList.add("loadtime");
    }
    // else {
    //   document.body.classList.remove('loadtime');
    // }

    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove("loadtime");
    };
  }, [Loading]); // Re-run this effect when MachineLoader changes
  const [input, setInput] = useState({
    userid: "",
    old_password: "",
    password: "",
    confirm_password: "",
    errors: {
      old_password: "",
      password: "",
      confirm_password: "",
      ValidationRules: [
        {
          FieldName: "old_password",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "password",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "confirm_password",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (input.confirm_password !== "" && input.password !== "") {
      if (input.confirm_password !== input.password) {
        setInput({
          ...input,
          errors: {
            ...input.errors,
            confirm_password: "Passwords do not match",
            password: "",
            // confirm_password: input?.confirm_password
            //   ? "Passwords do not match"
            //   : "This Field is a required field",
            // password: input?.password ? "" : input.password,
          },
        });
        return;
      }
    }
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        oldpassword: input.old_password.trim(),
        newpassword: input.password.trim(),
      };

      dispatch(UpdatePassword(body)).then((response) => {
        setLoading(false);
        if (response?.payload?.isValidate) {
          setChangePass(false);
        }
      });
    }
  };
  return (
    <div className="login-form-inner" style={{ width: "40%" }}>
      {Loading && <MainpageLoader />}
      <Form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <Form.Group className="form-group">
          <Form.Label className="login-label">
            Old Password
            <span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="input-type-pass">
            <Form.Control
              type={oldPasswordVisible ? "text" : "password"}
              placeholder="Enter your old password here"
              className="login-input"
              maxLength={67}
              value={input.old_password}
              onChange={(e) =>
                setInput({
                  ...input,
                  old_password: e.target.value,
                })
              }
              isInvalid={input?.errors?.old_password}
            />
            {input.errors.old_password && (
              <Form.Control.Feedback type="invalid">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.old_password}
                  />
                </span>
              </Form.Control.Feedback>
            )}
            <img
              src={oldPasswordVisible ? openeye : closeeye}
              alt="closeeye"
              onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
              loading="lazy"
            />
          </div>
        </Form.Group>
        <Form.Group className="form-group">
          <Form.Label className="login-label">
            New Password
            <span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="input-type-pass">
            <Form.Control
              type={passwordVisible ? "text" : "password"}
              placeholder="Enter your new password here"
              className="login-input"
              maxLength={67}
              value={input.password}
              onChange={(e) =>
                setInput({
                  ...input,
                  password: e.target.value,
                })
              }
              isInvalid={input?.errors?.password}
            />
            {input.errors.password && (
              <Form.Control.Feedback type="invalid">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.password}
                  />
                </span>
              </Form.Control.Feedback>
            )}
            <img
              src={passwordVisible ? openeye : closeeye}
              alt="closeeye"
              onClick={() => setPasswordVisible(!passwordVisible)}
            />
          </div>
        </Form.Group>
        <Form.Group className="form-group">
          <Form.Label className="login-label">
            Confirm Password
            <span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="input-type-pass">
            <Form.Control
              type={C_passwordVisible ? "text" : "password"}
              placeholder="Enter your confirm password here"
              className="login-input"
              maxLength={67}
              value={input.confirm_password}
              onChange={(e) =>
                setInput({
                  ...input,
                  confirm_password: e.target.value,
                })
              }
              isInvalid={input?.errors?.confirm_password}
            />
            {input.errors.confirm_password && (
              <Form.Control.Feedback type="invalid">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.confirm_password}
                  />
                </span>
              </Form.Control.Feedback>
            )}
            {input.confirm_password !== "" &&
            input.confirm_password === input.password ? (
              // input.confirm_password === "" &&
              //   input.confirm_password !== input.password &&
              <>
                {" "}
                <img src={verifiedIcon} alt="verified" />
              </>
            ) : (
              <img
                src={C_passwordVisible ? openeye : closeeye}
                alt="closeeye"
                onClick={() => setC_PasswordVisible(!C_passwordVisible)}
              />
            )}
          </div>
        </Form.Group>
        <div className="d-flex gap-2" style={{ width: "45%" }}>
          <button
            className="grey-btn"
            onClick={(e) => {
              setChangePass(false);
            }}
          >
            Cancel
          </button>{" "}
          <button disabled={Loading} className="blue-btn " type="submit">
            {Loading ? <SubmitLoading /> : "Update"}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ChangePassword;
